import { paths } from 'routes/paths';
import { History } from 'history';

const navigateToAppliedProduct = ({
  applicationId,
  taskId,
  recordName,
  history
}: {
  applicationId?: string;
  taskId?: string;
  recordName?: string;
  history: History;
}) => {
  const operationId = applicationId || taskId;

  if (!operationId) {
    return;
  }

  const params = new URLSearchParams();
  if (recordName) {
    params.set('search', recordName);
  }

  history.push({
    pathname: paths.applications,
    search: params.toString() ? `?${params.toString()}` : '',
    state: {
      operationId
    }
  });
};

export default navigateToAppliedProduct;
